export const animalTypes = state => {
    return state.animalTypes;
}